import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
} from "@mui/material";
import "./index.scss";
// import {
//   QUESTIONS,
//   loadCoolantConditionChecklist,
//   mappingDetailsToUI,
// } from "./coolent-condition-helper";

const RenderForm = ({ data, title, QUESTIONS, mappingDetailsToUI }) => {
  const [details, setDetails] = useState({});
  useEffect(() => {
    setDetails(mappingDetailsToUI(data));
  }, [data]);
  return (
    <Box className="coolant-condition-container">
      <Box className="header-row">
        <Typography variant="h5" className="header-title">
          {title}
        </Typography>
      </Box>
      {QUESTIONS?.map((question, index) => (
        <Box className="question-container" key={question.label}>
          <Typography variant="h6" className="question-title">
            {index + 1}. {question.label}
          </Typography>
          <Box className="row">
            {question.type === "INPUT" && (
              <Box className="input-container">
                <TextField
                  value={details[question.apiKey] || ""}
                  variant="outlined"
                  size="small"
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Box>
            )}
            {/* {question.options.map((option) => (
              <Box key={option.label} className="option-container">
                {option.type === "INPUT" ? (
                  <Box className="input-container">
                    <Typography variant="body1" className="input-label">
                      {option.label}
                    </Typography>
                    <TextField
                      value={details[option.apiOptionKey] || ""}
                      variant="outlined"
                      size="small"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Box>
                ) : (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!details[option.apiOptionKey]}
                        readOnly
                      />
                    }
                    label={option.label}
                  />
                )}
              </Box>
            ))} */}
            {question.options &&
              question.type !== "RADIO" &&
              question.options.map((option) => {
                if (option.type === "INPUT") {
                  return (
                    <Box className="input-container">
                      <TextField
                        value={`${details[option.apiOptionKey] || ""}`}
                        variant="outlined"
                        size="small"
                        label={option.label}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Box>
                  );
                } else {
                  return (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={!!details[option.apiOptionKey]}
                          readOnly
                        />
                      }
                      label={option.label}
                    />
                  );
                }
              })}

            {question.type === "RADIO" && (
              <FormControl>
                <RadioGroup row value={details[question.apiKey]}>
                  {question.options?.map((ele) => (
                    <FormControlLabel
                      value={ele.value}
                      control={
                        <Radio
                          checked={details[question.apiKey] === ele.value}
                        />
                      }
                      label={ele.label}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default RenderForm;
